import { useContext, useState } from 'react';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  RadioGroup,
} from '@material-ui/core';

import { FiRefreshCw } from 'react-icons/fi';
import { useBooleanState } from '../../../../hooks';
import { MAIN_CONTAINER_ID } from '../../../../constants';
import { AppRoundedRadio } from '../../../../components/inputs';
import { DeviceContext } from '../../../../contexts';

type RestoreType = 'all' | 'selected';

export const RestoreShiftRules = ({ handleConfirm }: { handleConfirm: (variant: RestoreType) => void }) => {
  const [restoreType, setRestoreType] = useState<RestoreType>('selected');
  const [isSuccessDialogOpen, setSuccessDialogOpen, setSuccessDialogClose] = useBooleanState(false);
  const { isMobile } = useContext(DeviceContext);

  const handleClick = () => {
    handleConfirm(restoreType);
    setSuccessDialogClose();
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    setRestoreType(value as RestoreType);
  };
  return (
    <>
      <Button
        endIcon={<FiRefreshCw />}
        variant="outlined"
        color="primary"
        size="small"
        onClick={setSuccessDialogOpen}
      >
        Restore to default
      </Button>
      <Dialog
        fullScreen={isMobile}
        open={isSuccessDialogOpen}
        container={document.getElementById(MAIN_CONTAINER_ID)}
        disableScrollLock
        onClose={setSuccessDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Restore Additional Rules to default</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Which settings would you like to restore? This action cannot be undone.
          </DialogContentText>
          <FormControl>
            <RadioGroup aria-label="restore-type" value={restoreType} onChange={handleChange}>
              <Box display="flex" flexDirection="column">
                <FormControlLabel
                  value="selected"
                  control={<AppRoundedRadio color="primary" />}
                  label="Settings of the selected Shift"
                />
                <FormControlLabel
                  value="all"
                  control={<AppRoundedRadio color="primary" />}
                  label="Settings of all the Shifts"
                />
              </Box>
            </RadioGroup>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button size="large" style={{ minWidth: 115 }} variant="outlined" onClick={setSuccessDialogClose}>
            Cancel
          </Button>

          <Button
            size="large"
            cy-test-id="confirm-button"
            style={{ minWidth: 115 }}
            color="primary"
            onClick={handleClick}
            variant="contained"
          >
            Restore
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
